import { useEffect } from 'react';

export function Modal({ open, onClose, size = 'md', children, style, overlayStyle }) {
  const sizeClass = { sm: 'modal-sm', md: 'modal-md', lg: 'modal-lg' }[size] || 'modal-md';

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape' && open) onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  return (
    <div className={`ovl${open ? ' open' : ''}`} style={overlayStyle}
         onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`modal ${sizeClass}`} style={style} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

export default Modal;

export function ModalHeader({ icon, title, subtitle, onClose, extra }) {
  return (
    <div className="mhd">
      {icon && <div className="m-ico">{icon}</div>}
      <div>
        <div className="m-tit">{title}</div>
        {subtitle && <div className="m-sub">{subtitle}</div>}
      </div>
      {extra && <div style={{ marginLeft: 'auto', display: 'flex', gap: 5, alignItems: 'center' }}>{extra}</div>}
      <button className="m-cls" onClick={onClose} style={extra ? {} : { marginLeft: 'auto' }}>×</button>
    </div>
  );
}

export function ModalBody({ children, style }) {
  return <div className="mbdy" style={style}>{children}</div>;
}

export function ModalFooter({ children }) {
  return <div className="mft">{children}</div>;
}
